import { render, staticRenderFns } from "./ComplianceReviewSearch.vue?vue&type=template&id=b4caadb6&scoped=true"
import script from "./ComplianceReviewSearch.vue?vue&type=script&lang=js"
export * from "./ComplianceReviewSearch.vue?vue&type=script&lang=js"
import style0 from "./ComplianceReviewSearch.vue?vue&type=style&index=0&id=b4caadb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4caadb6",
  null
  
)

export default component.exports